/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Goodforguestsvoters3Inputs */

const en_goodforguestsvoters3 = /** @type {(inputs: Goodforguestsvoters3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} people`)
};

const de_goodforguestsvoters3 = /** @type {(inputs: Goodforguestsvoters3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Personen`)
};

/**
* | output |
* | --- |
* | "{count} people" |
*
* @param {Goodforguestsvoters3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforguestsvoters3 = /** @type {((inputs: Goodforguestsvoters3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforguestsvoters3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforguestsvoters3(inputs)
	return de_goodforguestsvoters3(inputs)
});
export { goodforguestsvoters3 as "goodForGuestsVoters" }